import React from "react";
import PropTypes from "prop-types";
import ReactECharts from "echarts-for-react";

// Extracting data for the chart

const BarEcharts = (props) => {
  const { data } = props;
  const xAxisData = data.map((item) => item.date);
  const timeDepartedPlantData = data.map((item) => item.timeDepartedPlant);
  const timeAtDCData = data.map((item) => item.timeAtDC);
  const timeTotalData = data.map((item) => item.timeTotal);
  const gatewayCountData = data.map((item) => item.gatewayCount);

  const option = {
    title: {
      text: "",
      left: "left",
      top: "top",
      textStyle: {
        fontSize: 18,
        fontWeight: "bold",
        color: "#333",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      }
    },
    toolbox: {
      show: true,
      feature: {
        dataZoom: { yAxisIndex: "none" },
        restore: {},
        mark: { show: true },
        dataView: { show: true, readOnly: true },
        saveAsImage: { show: true, name: "" },
      },
    },
    grid: {
      left: 60, // Increased space on the left
      top: 60, // Space from the top
      right: 50, // Space on the right
      bottom: 60, // Increased space at the bottom
    },
    legend: {
      data: ["Time Departed Plant", "Time Departed DC", "Total Time", "cycle count"],
      left: "center",
    },
    xAxis: [
      {
        type: "category",
        name: "Date",
        position: "down",
        data: xAxisData,
        nameGap: 40,
        boundaryGap: true, // Ensures bars are properly aligned
        nameLocation: "center", // This positions the name centrally on the x-axis
        nameRotate: 0, // Adjust if you need rotation for the x-axis name
        axisLabel: {
          interval: 0, // Show all labels
          
          // rotate: 45 // Rotate labels if needed to avoid overlap
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "Avg Days",
        position: "left",
        axisLabel: {
          formatter: "{value}",
        },
        nameGap: 40,
        nameRotate: 90,
        nameLocation: "middle",
      },
      {
        type: "value",
        name: "Cycle count",
        min: 0,
        max: 600,
        nameGap: 35,
        nameRotate: -90,
        nameLocation: "middle",
      },
    ],
    series: [
      {
        name: "Time Departed Plant",
        type: "bar",
        data: timeDepartedPlantData,
        barWidth: "20%", // Adjust bar width
        itemStyle: {
          color: "#006FC1",
        },
        emphasis: {
          focus: "series",
        },
        barGap: "-100%", // Ensures bars overlap
        z: 10,
      },
      {
        name: "Time Departed DC",
        type: "bar",
        data: timeAtDCData,
        barWidth: "20%", // Same width for consistency
        itemStyle: {
          color: "#63D48E",
        },
        emphasis: {
          focus: "series",
        },
        barGap: "-100%", // Ensures bars overlap
        z: 5,
      },
      {
        name: "Total Time",
        type: "bar",
        data: timeTotalData,
        barWidth: "20%", // Same width for consistency
        itemStyle: {
          color: "#FF8027",
        },
        emphasis: {
          focus: "series",
        },
        barGap: "-100%", // Ensures bars overlap
        z: 0,
      },
      {
        name: "cycle count",
        type: "line",
        yAxisIndex: 1,
        data: gatewayCountData,
        itemStyle: {
          color: "#E084F9",
        },
      },
    ],
  };

  return (
      <ReactECharts option={option} />
  );
};

BarEcharts.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      timeDepartedPlant: PropTypes.number,
      timeAtDC: PropTypes.number,
      timeTotal: PropTypes.number,
      gatewayCount: PropTypes.number,
    })
  )
};
export default BarEcharts;
